import React, {useEffect, useState} from 'react'

function useScroll(debounce = 50) {
  const [scroll, setScroll] = useState({scrollX: 0, scrollY: 0})
  const [lastUpdate, setLastUpdate] = useState(Date.now())

  function calculateScroll() {
    if (typeof window === 'undefined') return {scrollX: 0, scrollY: 0}
    const {scrollX, scrollY} = window
    return {scrollX, scrollY}
  }

  useEffect(() => {
    function handleScroll() {
      if (Date.now() - lastUpdate < debounce) return

      setLastUpdate(Date.now())
      setScroll(calculateScroll())
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [lastUpdate, debounce])

  return scroll
}

export default useScroll

export function withScroll(ComposedComponent, debounce = 50) {
  return function WithScrollComponent(props) {
    const scroll = useScroll(debounce)
    return <ComposedComponent {...props} {...scroll} />
  }
}
